<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

        <el-row :span="2" style="margin-top: 30px;">
            <el-select v-model="value"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in options"
                  :key="item.label"
                  :label="item.label"

                  :value="item.value">
                </el-option>

              </el-select>
            <el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-select v-model="seachLid"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in options"
                  :key="item.label"
                  :label="item.label"

                  :value="item.value">
                </el-option>

              </el-select>
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>
        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="500"
              label="指令"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="功能名称"
               >
               <template slot-scope="scope">
                 <div>{{scope.row.lidName}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="时间"
               >
               <template slot-scope="scope">
                 <div>{{scope.row.time}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="更新"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="up(scope.row.id)">更新</el-col>
                   <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
                 </el-row>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="推荐"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" v-if="scope.row.st == 0" @click.native="tuijian(scope.row.id)">推荐</el-col>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;color: #006600;" v-if="scope.row.st == 1" >已推荐</el-col>
                 </el-row>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="删除"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id)">删除</el-col>
                   <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
                 </el-row>
               </template>
            </el-table-column>

            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>

    </el-container>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         value: '',
         name:'',
         options: [],
         seachLid:'',
         seachName:''

      }
    },
  directives: {
    },
    created() {
      this.loadop();
      this.loadList();

    },

  methods:{
    tuijian(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          t:'a'
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/qatTuijian'
      })
      .then(res=>{
      	this.$message({
      		type: 'success',
      		message: '推荐成功'
      	});
        this.loadList();
      })
      .catch(err=>{

      });
    },
    loadop(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']

    	})
    	.catch(err=>{

    	});
    },
    seach(){
      this.loadList();
    },



    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          lid:this.seachLid,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/qadatalist'
      })
      .then(res=>{

        this.list = res.data.list;

        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },
    del(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          tb:'qa'
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/assemblyDel'
      })
      .then(res=>{
      	this.$message({
      		type: 'success',
      		message: '删除成功'
      	});
        this.loadList();
      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.$message({
        	type: 'error',
        	message: '指令不能为空'
        });
        return false
      }
      axiosInstance({
      	method:'get',
      	url:'http://y31p.yoooooo.com/index.php/index/data/qaAdd',
      	params:{
          text:this.name,
          lid:this.value
        }
      })
      .then(res=>{
        if(res.data.code == 200){
           this.$message({
           	type: 'success',
           	message: res.data.msg
           });
           this.loadList();
        }else{
          this.$message({
          	type: 'error',
          	message: res.data.msg
          });
        }

      })
      .catch(err=>{

      });
    },
    up(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/qaUpdate',
      	params:{
          id:id
        }
      })
      .then(res=>{
        if(res.data.code == 200){
           this.$message({
           	type: 'success',
           	message: res.data.msg
           });
           this.loadList();
        }else{
          this.$message({
          	type: 'error',
          	message: res.data.msg
          });
        }

      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/qadata.vue